/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_EintrittsdatumInputs */

const de__field_eintrittsdatum = /** @type {(inputs: _Field_EintrittsdatumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eintrittsdatum`)
};

/**

* @param {_Field_EintrittsdatumInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_eintrittsdatum = /** @type {((inputs?: _Field_EintrittsdatumInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_EintrittsdatumInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_eintrittsdatum(inputs)
});